export const CERTIFICATIONS = {
	license: 'license',
	certification: 'certification',
}
